<template>
<modal @close="onModalClose" :no-footer="true">
    <template slot="header">
        Checking Charges for {{ facility.facility_number }}
    </template>

    <template slot="content">
        <loading-wrapper :loading="is_loading">
            <div v-if="is_loading">&nbsp;</div>

            <div v-else>
                <div v-if="error_message !== null">
                    <strong class="danger-text">Error!</strong> {{ error_message }}
                </div>

                <div v-else>
                    <div class="mb-3">
                        <strong>Check complete!</strong>
                        <span v-if="confirmed_tenants === 1">Confirmed 1 charge.</span>
                        <span v-else>Confirmed {{ confirmed_tenants.length.toLocaleString() }} tenants.</span>
                    </div>

                    <vue-table ref="tenants_table"
                        :api-mode="false"
                        :data="confirmed_tenants"
                        :fields="columns"
                        no-data-template="<span>No charges were confirmed.</span>">
                        <template slot="full_name" slot-scope="props">
                            <span v-if="props.rowData.last_name === null">
                                {{ props.rowData.first_name }}
                            </span>

                            <span v-else>
                                {{ props.rowData.last_name }}, {{ props.rowData.first_name }}
                            </span>
                        </template>
                        <template slot="insurance_effective_date" slot-scope="props">
                            <div class="flex ai-c jc-sb">
                                <span>{{ props.rowData.insurance_effective_date }}</span>

                                <span
                                    v-if="props.rowData.insurance_effective_date !== props.rowData.original_insurance_effective_date && props.rowData.original_insurance_effective_date !== null"
                                    :title="`Original Date: ${props.rowData.original_insurance_effective_date}`"
                                    class="cu-h material-icons secondary-text">
                                    update
                                </span>
                            </div>
                        </template>
                    </vue-table>
                </div>
            </div>
        </loading-wrapper>
    </template>
</modal>
</template>

<script>
import http from "@/http"
import { wait } from "@/utilities/misc"

export default {
    props: {
        facility: {
            required: true,
            type: Object
        }
    },

    data () {
        return {
            columns: [
                {
                    name: "unit",
                    title: "Unit"
                },
                {
                    name: "__slot:full_name",
                    title: "Tenant Name"
                },
                {
                    name: "__slot:insurance_effective_date",
                    title: "Insurance Effective Date",
                    width: "200px"
                }
            ],
            confirmed_tenants: [],
            error_message: null,
            is_loading: true
        }
    },

    computed: {
        formatted_tenants () {
            return this.confirmed_tenants.map((tenant) => {
                let fullName = ""

                if (tenant.last_name === null) {
                    fullName = tenant.first_name
                } else {
                    fullName = `${tenant.last_name}, ${tenant.first_name}`
                }

                return Object.assign({
                    full_name: fullName
                }, tenant)
            })
        }
    },

    async mounted () {
        await wait(150)

        this.checkCharges()
    },

    methods: {
        async checkCharges () {
            this.is_loading = true

            try {
                const { data } = await http(`/api/facilities/${this.facility.id}/check-charges`)

                this.confirmed_tenants = data
            } catch (ex) {
                if (ex.message) {
                    this.error_message = ex.message
                } else {
                    this.error_message = ex
                }
            } finally {
                this.is_loading = false
            }
        },

        onModalClose () {
            this.$emit("close")
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/insurance-policy-management-page/CheckChargesModal.vue